
export default function RegistrationFailure() {
  return <>Registration Failure</>;
}
